<template>
    <div class="pt-4">
        <h1>Menu <span v-if="staffRoute">{{ $route.params.slug | title('-') }}</span> <vs-button type="filled" icon="save" class="float-right" @click="saveCategories">Opslaan</vs-button></h1>
        <vs-card class="mt-6" v-if="!staffRoute">
            <p class="text-xl">
                <b>Disclaimer</b><br>
                Het portaal zal voorzien worden van een nieuw database, wat sorteren en bewerken nog makkelijker zal maken. Helaas zal dit pas medio december voltooid zijn. Tot die tijd dien je als volgt het menu aan te passen:
            </p>
            <p class="text-xl mt-4">
                Sleep de <b>categorie</b>, <b>product</b> of <b>product-optie</b> op de juiste positie en klik vervolgens op <b>opslaan</b>.
            </p>
            <p class="text-xl italic mt-4">
                Let op: Opties die aan meerdere producten staan gekoppeld dienen per individueel product van positie gewijzigd te worden; bij alle gekoppelde producten! Indien dit niet gebeurd, zal de positie-wijziging niet doorgevoerd worden.
            </p>
        </vs-card>
        <ht-menu-list class="mt-8"></ht-menu-list>
    </div>
</template>

<script>
import HtMenuList from './components/list'
export default {
    components: {
        HtMenuList
    },
    methods: {
        saveCategories: function() {
            this.$events.fire('save-company-menu')
        }
    },
    computed: {
        staffRoute () {
            if(this.$route.meta.staff) {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
            } else {
                if(localStorage.getItem('stafftoken') !== null) {
                    return true
                }
                return false
            }
        },
    }
}
</script>

<style>

</style>
